<template>
  <v-card flat>
    <v-card-title>
      <v-text-field solo dense hide-details v-model="scanCode" id="scanCode" autocomplete="off"
        ref="scanFocus" @click="selectContent" @change="getRespectiveProductOrder"
        :placeholder="$t('message.dashboard.scanText')"></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-btn color="primary" block @click="$router.push('customer_orders')" class="text-center">
        {{ $t('message.dashboard.customerOrder') }}
        <v-icon class="mdi-spin ml-2" v-if="loading">mdi-loading</v-icon>
        <template v-else>({{ customerOrders }})</template>
      </v-btn>
      <!-- <v-btn color="primary" block @click="storeSales > 0 ? $router.push('store_sale') : $router.push('store_sale/create')" class="text-center mt-4">
        {{ $t('message.dashboard.inStoreSale') }}
        <v-icon class="mdi-spin ml-2" v-if="loading">mdi-loading</v-icon>
        <template v-else>({{ storeSales }})</template>
      </v-btn> -->
      <v-btn color="primary" block @click="$router.push('supplier_orders')" class="text-center mt-4">
        {{ $t('message.dashboard.receiveSupplierOrder') }}
        <v-icon class="mdi-spin ml-2" v-if="loading">mdi-loading</v-icon>
        <template v-else>({{ supplierOrders }})</template>
      </v-btn>
      <v-btn color="primary" block @click="$router.push('adjustment_orders')" class="text-center mt-4">
        {{ $t('message.dashboard.adjustmentOrders') }}
        <v-icon class="mdi-spin ml-2" v-if="loading">mdi-loading</v-icon>
        <template v-else>({{ adjustmentOrders }})</template>
      </v-btn>
      <v-btn color="primary" block @click="$router.push('cycle_count')" class="text-center mt-4">
        {{ $t('message.dashboard.cycleCount') }}
        <v-icon class="mdi-spin ml-2" v-if="loading">mdi-loading</v-icon>
        <template v-else>({{ cycleCount }})</template>
      </v-btn>
      <v-btn color="primary" block @click="$router.push('product_view')" class="text-center mt-4">{{ $t('message.dashboard.product') }}</v-btn>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      customerOrders: 0,
      supplierOrders: 0,
      adjustmentOrders: 0,
      transferOrders: 0,
      cycleCount: 0,
      storeSales: 0,
      scanCode: '',
      loading: true
    }
  },
  mounted () {
    this.getTotalCountOfOrders()
    requestAnimationFrame(() => {
      if (this.$refs.scanFocus) {
        this.$refs.scanFocus.focus()
      }
    })
    this.$store.commit('scannedValue', '')
  },
  methods: {
    getTotalCountOfOrders () {
      this.loading = true
      this.$api.execute('get', 'orders/get_order_counts')
        .then((response) => {
          if (response.data) {
            let { customerordertotal, supplierordertotal, transferordertotal, adjustmentordertotal, ccsheettotal, storesaletotal } = response.data
            this.customerOrders = customerordertotal
            this.supplierOrders = supplierordertotal
            this.adjustmentOrders = adjustmentordertotal
            this.transferOrders = transferordertotal
            this.cycleCount = ccsheettotal
            this.storeSales = storesaletotal
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectContent () {
      if (this.$refs.scanFocus) {
        setTimeout(() => {
          document.getElementById('scanCode').select()
        }, 50)
      }
    },
    getRespectiveProductOrder () {
      this.$api.execute('get', `orders/get_respective_view/${this.scanCode}`)
        .then((response) => {
          if (response.data) {
            this.$store.commit('scannedValue', this.scanCode)
            this.$router.push(response.data)
          }
        })
    }
  }
}
</script>
